/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { movieRatingValueSchema } from '../movie-rating-value-schema';

export const rateMovieV1RequestSchema = z
  .object({
    watched: z.boolean().optional(),
    rating: movieRatingValueSchema.nullable().optional(),
    wantsToWatch: z.boolean().optional(),
    watchCount: z.number().int().min(0).optional(),
  })
  .refine((body) => Object.keys(body).length > 0, { message: 'At least one field is required' });

export type IRateMovieV1Body = z.infer<typeof rateMovieV1RequestSchema>;

export interface IRateMovieV1Request extends IRateMovieV1Body {
  collectionId: number;
}
